// import request from '@/utils/request'
import axios from '@/http/api'


//login //用户登录
export const loginByUsername = data => {
  return axios({
    url: '/consoleGateway/userInfoController/loginValidate',
    method: 'post',
    data
  })
}
//login //用户登录
export const loginForHTX = data => {
  return axios({
    url: '/IQThirdService/userInfoController/loginForHTX',
    method: 'post',
    data
  })
}


// export function loginByUsername(username, password) {
//   const data = {
//     username,
//     password
//   }
//   return request({
//     url: '/login/login',
//     method: 'post',
//     data
//   })
// }



// export function logout() {
//   // return request({
//   //   url: '/login/logout',
//   //   method: 'post'
//   // })
// }
//logout//退出登录
export const logout = data => {
  return axios({
    url: '/consoleGateway/userInfoController/logout',
    method: 'post',
    data
  })
}
export function getUserInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

//getSystemTimes//获取系统时间
export const getSystemTime = data => {
  return axios({
    url: '/consoleGateway/userInfoController/getSystemTime',
    method: 'post',
    data
  })
}


export  const  updateUserPassword = data =>{
  return axios({
    url: '/consoleGateway/userInfoController/updateUserPassword',
    method: 'post',
    data
  })
}

export  const  getVerificationCodeImg1 = data =>{
  return axios({
    url: '/consoleGateway/validate/getVerificationCodeImg',
    method: 'post',
    data
  })
}

//获取验证码
export  const  getVerificationCodeImg = data =>{
  return '/IQCloudMainPro/validate/getCodeImg'
}

//是否需要显示验收码
export  const  selectDisVerificationCode = data =>{
  return axios({
    url:'/consoleGateway/validate/selectDisVerificationCode',
    method:'post',
    data
  })
}
//是否需要显示验收码
export  const  getVerificationCodeData = data =>{
  return axios({
    url:'/consoleGateway/validate/getVerificationCodeData',
    method:'get',
    data
  })
}

//获取用户具有的功能权限
export  const  selectUserBindRoleByUserId = data =>{
  return axios({
    url:'/consoleGateway/roleController/selectUserBindRoleByUserId',
    method:'post',
    data
  })
}

//3.4.1 获取终端组织的地址、时区
export  const  selectPriCloudTimeInfo = data =>{
  return axios({
    url:'/consoleGateway/cloudTimeInfoController/selectPriCloudTimeInfo',
    method:'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/login.js